import { transformResponse, v3Api } from './axios'

export const createInvitation = (data: any, token: string) =>
  transformResponse(
    v3Api.post('/invitation', data, {
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    }),
  )
